import { translateToEmpty, translateToDate, translateToYuan, translateByDict } from '@/utils/translators'

export const filterToEmpty = value => translateToEmpty(value)

export const filterToDate = value => translateToDate(value)

export const filterToYuan = value => translateToYuan(value)

export const filterToLabel = (value, dict) => translateByDict(value, dict, 'code', 'name')
